import { Injectable } from '@angular/core';
import { AbstractControl,ValidatorFn } from '@angular/forms';

@Injectable()
export class SelectboxValidators {

    validateRequiredNumber(required = true): ValidatorFn  {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!required) return null;

            return ((control.value == null) || (control.value == '') || ((+control.value) == Number.MIN_VALUE) || 
                ((+control.value) == Number.NEGATIVE_INFINITY)) ? { 'invalidNumber': { value: control.value } } : null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/selectbox.validators.ts